import template from "./navbar-over-quote.html";
import Visibility from "visibilityjs";

const NavbarOverQuoteComponent = {
  bindings: {
    quote: "<",
  },
  template: template,
  controller: class NavbarOverQuoteController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $window,
      $sce,
      $interval,
      $http,
      $filter,
      Utils,
      Quote,
      SweetAlertService,
      ModalsManager,
      QuoteTemplate,
      SecurityManager,
      Notification,
      uuid,
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$window = $window;
      this.$sce = $sce;
      this.$interval = $interval;
      this.$http = $http;
      this.$filter = $filter;
      this.Utils = Utils;
      this.Quote = Quote;
      this.SweetAlertService = SweetAlertService;
      this.ModalsManager = ModalsManager;
      this.QuoteTemplate = QuoteTemplate;
      this.SecurityManager = SecurityManager;
      this.NotificationService = Notification;
      this.uuid = uuid;
    }

    // $onInit () {
    //   const sessionId = this.uuid.v4()
    //   this.visibilityCounter = Visibility.every(5000, () => {
    //     this.quote.recordEditingTime({sessionId: sessionId, editingSeconds: 5})
    //   })
    // }
    //
    // $onDestroy () {
    //   Visibility.stop(this.visibilityCounter)
    // }

    getShowQuoteUrl(quote) {
      if (!this.$rootScope.organization) throw new Error("Organization was not loaded yet.");
      return this.$sce.trustAsResourceUrl(`${this.$rootScope.organization.getDomainUrl()}/show/${quote.token}`);
    }

    async downloadPDF() {
      const pdfStatusId = await this.Quote.generatePdf(this.quote._id, this.quote.lastVersion.number);

      if (pdfStatusId && pdfStatusId.status_id) {
        this.SweetAlertService.generatingPdf();
        const intervalCheckPdfStatus = this.$interval(
          async () => {
            const status = await this.Quote.checkPdfStatus({
              pdfStatusId: pdfStatusId.status_id,
            }).catch((e) => {
              this.$interval.cancel(intervalCheckPdfStatus);
              this.SweetAlertService.close();
            });
            if (status && status.download_url) {
              this.$interval.cancel(intervalCheckPdfStatus);
              this.$http
                .get(status.download_url, { responseType: "arraybuffer" })
                .then((response) => {
                  const file = response.data;
                  const a = document.createElement("a");
                  document.body.appendChild(a);
                  a.style = "display: none";
                  a.href = this.$window.URL.createObjectURL(new Blob([file], { type: "application/pdf" }));
                  a.download =
                    this.quote.code +
                    " - " +
                    this.Utils.slugify(this.quote.description.slice(0, 50)) +
                    " (v" +
                    this.quote.lastVersion.number +
                    ").pdf";
                  a.click();
                  a.remove();
                })
                .catch((e) => {
                  this.$interval.cancel(intervalCheckPdfStatus);
                  this.SweetAlertService.close();
                });
              this.SweetAlertService.close();
            }
          },
          1000,
          60,
        );
      }
    }

    async openQuoteTemplateCreateOverwriteModal() {
      const quoteTemplate = await this.ModalsManager.openQuoteTemplateCreateOverwriteModal(this.quote._id);
    }

    async remove() {
      if (!(await this.SweetAlertService.wantRemoveQuote())) return;
      await this.quote.delete();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.quoteRemoved"),
      });
      this.$state.go("app.dashboard");
    }

    async launchShareModal() {
      await this.ModalsManager.openQuoteShareModal(this.quote, true);
    }

    async launchEditHeaderModal() {
      const quote = await this.ModalsManager.openQuoteHeaderModal({
        edit: true,
        quote: this.quote,
      });
      if (quote) this.$state.reload();
    }
  },
};

export default NavbarOverQuoteComponent;
